<template>
    <main class="main services">
        <div class="container">
            <section-header
                title="Usługi"
                sub-title="
                    Odkrywaj usługi dostępne dzięki technologii EuroPlatform.
                    Pomogą Ci one lepiej zarządzać sklepem i oferować dodatkowe aktywności dla Twoich klientów
                "
            />

            <page-preloader
                v-if="servicesStatus === 'loading'"
            />

            <div v-else>
                <div>
                    <div class="d-flex align-items-center gap-0-5">
                        <h3 class="services-heading d-sm-block d-none">
                            Usługi dostępne do aktywacji
                        </h3>
                        <h3 class="services-heading d-sm-none d-block">
                            Dostępne do aktywacji
                        </h3>
                        <span v-if="isAvailableServices" class="a-counter">
                            {{ availableServices.length }}
                        </span>
                    </div>
                    <div
                        v-if="isAvailableServices"
                        class="row row-cols-1 row-cols-md-2 row-cols-lg-3"
                    >
                        <service-preview
                            v-for="(service, idx) in availableServices"
                            :is-available-section="true"
                            :key="`available-${idx}`"
                            :service="service"
                            @activateService="fetch"
                        />
                    </div>
                    <p class="services-lead-text mt-2" v-else>
                        Dobra robota! Wszystkie zaproponowane usługi zostały
                        aktywowane!
                    </p>
                </div>
                <div class="mt-5">
                    <div class="d-flex align-items-center gap-0-5">
                        <h3 class="services-heading d-sm-block d-none">
                            Usługi, które są już aktywne w Twoich sklepach
                        </h3>
                        <h3 class="services-heading d-sm-none d-block">
                            Aktywne w Twoich sklepach
                        </h3>
                        <span v-if="isActiveServices" class="a-counter">
                            {{ activeServices.length }}
                        </span>
                    </div>
                    <div
                        v-if="isActiveServices"
                        class="row row-cols-1 row-cols-md-2 row-cols-lg-3 "
                    >
                        <service-preview
                            v-for="(service, idx) in activeServices"
                            :is-available-section="false"
                            :key="`active-${idx}`"
                            :service="service"
                            @activateService="fetch"
                        />
                    </div>
                    <p class="services-lead-text mt-2" v-else>
                        Nie masz włączonych usług. Zapoznaj się z usługami
                        dostępnymi do aktywacji w Twoich sklepach.
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ServicePreview from '@/components/services/ServicePreview'

export default {
    components: {
        ServicePreview
    },
    created() {
        this.fetch()
    },
    computed: {
        activeServices() {
            return this.$store.getters.getServicesByStatus('active')
        },
        isActiveServices() {
            return this.activeServices?.length
        },
        availableServices() {
            return this.$store.getters.getServicesByStatus('available')
        },
        isAvailableServices() {
            return this.availableServices?.length
        },
        servicesStatus() {
            return this.$store.getters.getServicesStatus
        }
    },
    methods: {
        fetch() {
            this.$store.dispatch('servicesFetch')
        }
    }
}
</script>
